import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { ChevronDownIcon, XMarkIcon } from "@heroicons/react/24/outline";
import kw from "../../assets/images/Flags/kw.png";
import sa from "../../assets/images/Flags/sa.png";
import bh from "../../assets/images/Flags/bh.png";
import ae from "../../assets/images/Flags/ae.png";
import qa from "../../assets/images/Flags/qa.png";
import om from "../../assets/images/Flags/om.png";
import jo from "../../assets/images/Flags/jo.png";
import eg from "../../assets/images/Flags/eg.png";
// new
import usd from "../../assets/images/Flags/us.png";
import eur from "../../assets/images/Flags/eu.png";
import tryFlag from "../../assets/images/Flags/tr.png";
import gbp from "../../assets/images/Flags/gb.png";
import dz from "../../assets/images/Flags/dz.png";
import sy from "../../assets/images/Flags/sy.png";
import ma from "../../assets/images/Flags/ma.png";

import { useDispatch } from "react-redux";
import { changeCurrencyIso } from "../../redux/reducer/currancyReducer";
import useLanguageDirection from "../../hooks/useLanguageDirection";
import { getCurrencyAndLanguageSymbol } from "../../constent/currencyUtils";

const countries = [
  { name: "Saudi Riyal", nameAr: "ريال سعودي", currency: "SAR", flag: sa },
  { name: "Kuwaiti Dinar", nameAr: "دينار كويتي", currency: "KWD", flag: kw },
  { name: "Bahraini Dinar", nameAr: "دينار بحريني", currency: "BHD", flag: bh },
  { name: "UAE Dirham", nameAr: "درهم إماراتي", currency: "AED", flag: ae },
  { name: "Qatari Riyal", nameAr: "ريال قطري", currency: "QAR", flag: qa },
  { name: "Omani Rial", nameAr: "ريال عماني", currency: "OMR", flag: om },
  { name: "Jordanian Dinar", nameAr: "دينار أردني", currency: "JOD", flag: jo },
  { name: "Egyptian Pound", nameAr: "جنيه مصري", currency: "EGP", flag: eg },
  { name: "US Dollar", nameAr: "دولار أمريكي", currency: "USD", flag: usd },
  { name: "Euro", nameAr: "يورو", currency: "EUR", flag: eur },
  {
    name: "Turkish Lira",
    nameAr: "ليرة تركية",
    currency: "TRY",
    flag: tryFlag,
  },
  {
    name: "British Pound",
    nameAr: "جنيه إسترليني",
    currency: "GBP",
    flag: gbp,
  },
  { name: "Algerian Dinar", nameAr: "دينار جزائري", currency: "DZD", flag: dz },
  { name: "Syrian Pound", nameAr: "ليرة سورية", currency: "SYP", flag: sy },
  { name: "Moroccan Dirham", nameAr: "درهم مغربي", currency: "MAD", flag: ma },
];

const CustomDropDownNavBarCurrancy = ({ isMobile }) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState("KWD");
  const [selectedCountryName, setSelectedCountryName] = useState("Kuwait");
  const [selectedCountryFlag, setSelectedCountryFlag] = useState(
    countries[0]?.flag
  );
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;
  const dispatch = useDispatch();

  const popUpRef = useRef(null);
  const buttonRef = useRef(null);
  // const [isOpen, setIsOpen] = useState(false);
  const currencySymbol = getCurrencyAndLanguageSymbol();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        popUpRef.current &&
        !popUpRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsPopupOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const storedCurrency = localStorage.getItem("currency");
    const country = countries.find((c) => c.currency === storedCurrency);

    if (!storedCurrency || !country) {
      localStorage.setItem("currency", "KWD");
      setSelectedCurrency("KWD");
      setSelectedCountryName("Saudi");
      setSelectedCountryFlag(countries[0].flag);
    } else {
      setSelectedCurrency(storedCurrency);
      setSelectedCountryName(country.name);
      setSelectedCountryFlag(country.flag);
    }
  }, []);

  const handleCountryClick = (currencyCode) => {
    const country = countries.find((c) => c.currency === currencyCode);
    if (country) {
      setSelectedCurrency(currencyCode);
      setSelectedCountryName(country.name);
      setSelectedCountryFlag(country.flag);
      setIsPopupOpen(false);

      window.location.reload();

      dispatch(changeCurrencyIso(currencyCode)).catch((error) => {
        console.error("Change ISO failed:", error);
      });
      localStorage.setItem("currency", currencyCode);
    }
  };

  const direction = useLanguageDirection();

  return (
    <div>
      <button
        onClick={() => setIsPopupOpen(true)}
        className={`flex ${
          isMobile ? "flex-row-reverse" : ""
        } items-center gap-2 text-white group`}
        ref={buttonRef}
      >
        <ChevronDownIcon class="w-4 h-4 text-white duration-300  ms-1 group-hover:text-custom-yellow" />
        <span className="text-sm duration-300 group-hover:text-custom-yellow">
          {/* {t("ChangeCurrency")} */}
          {/* {selectedCurrency} */}
          {currencySymbol}
        </span>

        <img
          src={selectedCountryFlag}
          className="w-6 h-6 rounded-full lg:w-7 lg:h-7"
        />
      </button>

      {isPopupOpen && (
        <div
          className="fixed top-0 left-0 z-[99999999999999999] flex items-center justify-center w-full h-full text-black bg-black bg-opacity-50"
          dir={direction}
        >
          <div
            className="bg-white w-[90%] max-w-md max-h-[80vh] overflow-y-auto rounded-lg p-4 shadow-lg relative"
            ref={popUpRef}
          >
            <div className="flex items-center justify-between mb-3">
              <h2 className="text-lg font-bold text-black">
                {t("SelectYourCountry")}
              </h2>
              <button
                onClick={() => setIsPopupOpen(false)}
                className={`  top-2 ${
                  direction === "rtl" ? "left-2" : "right-2"
                }  `}
              >
                <XMarkIcon class="lg:w-7 lg:h-7 w-5 h-5  text-black" />
              </button>
            </div>
            <ul className="space-y-2">
              {countries.map((country, index) => (
                <li
                  key={index}
                  onClick={() => handleCountryClick(country.currency)}
                  className="flex items-center gap-2 p-2 text-black rounded cursor-pointer hover:bg-gray-100"
                >
                  <img
                    src={country.flag}
                    alt={country.name}
                    className="w-6 h-6 rounded-full "
                  />
                  {currentLang === "ar" ? country.nameAr : country.name}
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomDropDownNavBarCurrancy;
